/* eslint-disable max-len,no-unused-vars,react/prop-types */
import React from 'react';
import { graphql, Link } from 'gatsby';
import { Sine, TimelineMax } from 'gsap';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import SEO from '../../components/seo';
import './style.scss';
import Layout from '../../components/Layout';
import NavBar from '../../components/NavBar';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';
import PodsBackground from '../../images/backgrounds/pods-background.png';
import PodsChart from '../../images/product-images/pods-chart.svg';
import ProductItem from '../../components/ProductItem';
import Footer from '../../components/Footer';
import getCloudinary from '../../utils/getCloudinary';
import getBrowserWidth from '../../utils/getBrowserWidth';

const buyNowRef = React.createRef();
// eslint-disable-next-line react/prop-types
const PodsPage = ({ data, scrollPosition }) => (
    <Layout id="pods-page">
        <SEO
            title="CBD Pods – Shop Variety of flavours CBD Pods - DR WATSON"
            description="DR WATSON offer 5 flavours (2 x ~2ml pods) with 240mg of CBD Pods. It comes in a variety of flavours, like Wild Mint, Amalfi Lemon, Ice Peach, Brazilian Manage and Berry Kush."
        />

        <DrWatsonLargeLogo />
        <NavBar />

        <div className="nav-bar-below-content pods-page">
            <div
                className="header-background"
            >
                <div className="header-background__content">
                    <div
                        className="header-background__content__info"
                    >
                        <div className="title is-size-4-touch is-size-3-desktop has-text-centered-touch is-spaced">CBD Pods</div>
                        <div className="subtitle is-size-4-touch is-size-3-desktop has-text-centered-touch">5 flavours (2 x ~2ml pods) with 240mg of CBD</div>
                        <img
                            src={getCloudinary().url(
                                'dashboard-uploads/hovering-pod_payam6.png',
                                { height: 240, crop: 'fit', fetch_format: 'auto' },
                            )}
                            alt="Pod"
                            className="pod-image is-hidden-desktop"
                        />
                        <button
                            type="button"
                            className="buy-now-button button is-theme-success has-text-white is-large"
                            onClick={() => {
                                // eslint-disable-next-line no-undef
                                window.scrollTo({
                                    top: buyNowRef.current.offsetTop,
                                    behavior: 'smooth',
                                });
                            }}
                        >
                                Buy Now
                        </button>
                        {/* <div className="title is-size-6-touch is-size-5-desktop why-buy-this-title is-spaced has-text-centered-touch"> */}
                        {/*        Health Benefits */}
                        {/* </div> */}
                        {/* <div className="subtitle is-size-5-touch is-size-4-desktop content"> */}
                        {/*        Some of the benefits of the terpenes used in our products */}
                        {/*    <ul> */}
                        {/*        <li className="is-size-6-touch is-size-5-desktop">Memory boost, asthma and focus</li> */}
                        {/*        <li className="is-size-6-touch is-size-5-desktop">Anti-inflammatory, analgesic preventing plaque build-up in arteries and relief from toothaches</li> */}
                        {/*        <li className="is-size-6-touch is-size-5-desktop">Anti-tumor/anti-cancer properties (chemoprotective)</li> */}
                        {/*        <li className="is-size-6-touch is-size-5-desktop">Gastric reflux, anti-fungal and anti-anxiety</li> */}
                        {/*        <li className="is-size-6-touch is-size-5-desktop">Sedating, calming, insomnia</li> */}
                        {/*    </ul> */}
                        {/*    <Link to="dr-watson-cbd" className="button is-size-5-touch is-size-4-desktop read-more-button">Read More</Link> */}
                        {/* </div> */}
                    </div>
                </div>
                <img
                    src={PodsBackground}
                    alt="Pods Curve"
                    style={{ marginTop: '-1px', width: '100%' }}
                />
            </div>

            <div className="content-below-header">
                <img
                    src={getCloudinary().url(
                        'dashboard-uploads/hovering-pod_payam6.png',
                        { height: 640, crop: 'fit', fetch_format: 'auto' },
                    )}
                    alt="Pod"
                    className="pod-image is-hidden-touch"
                />
                <div className="pod-chart-container">
                    <div
                        className="pattern-background"
                        style={{
                            backgroundImage: `url("${getCloudinary().url(
                                'dashboard-uploads/white-diamond-background_mjkrp8',
                                { height: 500, crop: 'fit', fetch_format: 'auto' },
                            )}")`,
                        }}
                    >
                        <div className="pattern-background-gradient-overlay" />
                        <div className="pattern-foreground">
                            <img
                                src={PodsChart}
                                className="ace-cbd-delivery-system-chart"
                                alt="Ace CBD Delivery System Chart"
                            />
                        </div>
                    </div>
                </div>

                <img
                    src={getCloudinary().url(
                        'dashboard-uploads/pod_packs_green_banner_wa0jrb',
                        { fetch_format: 'auto', crop: 'fit', width: parseInt(getBrowserWidth() * 1.2, 10) },
                    )}
                    className="pods-banner"
                    alt="Pods Falling Banner"
                />
                <div className="products-list" ref={buyNowRef}>
                    <div className="container">
                        <div
                            className="title is-size-3-touch is-size-2-desktop has-text-centered has-text-white"
                        >
Variety
                                of flavours
                        </div>
                        <div className="columns is-multiline is-centered is-mobile is-marginless">
                            {
                                data.allStrapiProduct.edges.map(
                                    ({ node }) => node,
                                )
                                    .map(
                                        product => product.variants.map(
                                            variant => (
                                                <ProductItem
                                                    scrollPosition={scrollPosition}
                                                    product={{
                                                        ...product,
                                                        variant,
                                                    }}
                                                />
                                            ),
                                        ),
                                    )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </Layout>
);


export const query = graphql`
    query {
        allStrapiProduct (filter: {productgroup:{name:{eq: "Pods"}}}){
            edges {
                node {
                    name
                    description
                    slug
                    productgroup {
                        id
                        name
                    }
                    variants {
                        id
                        name
                        description
                        price
                        wholesale_price
                        isFeatured
                        images {
                            createdAt
                            url
                            public_id
                        }
                    }
                }
            }
        }
    }
`;

export default trackWindowScroll(PodsPage);
